import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

type UiSize = 'sm' | 'md';

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  /** Visual density. `sm` is the compact toolbar variant (32 px tall).
   *  Named `uiSize` because `size` is a native select attribute. */
  uiSize?: UiSize;
}

const sizeClass: Record<UiSize, string> = {
  sm: 'h-8 px-2 text-sm',
  md: 'h-10 px-3 text-sm',
};

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, children, uiSize = 'md', ...rest }, ref) => (
    <select
      ref={ref}
      className={cn(
        'block w-full rounded-md border border-slate-300 bg-white leading-5 shadow-sm',
        sizeClass[uiSize],
        'focus:border-forest-500 focus:outline-none focus:ring-1 focus:ring-forest-500',
        'dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100',
        'dark:focus:border-forest-400 dark:focus:ring-forest-400',
        className,
      )}
      {...rest}
    >
      {children}
    </select>
  ),
);
Select.displayName = 'Select';
